import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Star, Smartphone, Minus, Plus } from "lucide-react";
import api from "../api/axios";
import { useCart } from "../context/CartContext";

export default function ProductDetail() {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const { addToCart } = useCart();

  useEffect(() => {
    api.get(`/products/${slug}`).then((res) => setProduct(res.data));
  }, [slug]);

  if (!product) return <div className="max-w-4xl mx-auto px-4 py-20 text-white/50">Loading...</div>;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 grid md:grid-cols-2 gap-10">
      <div className="aspect-square bg-gradient-to-br from-slate-700 to-slate-900 rounded-2xl flex items-center justify-center">
        {product.images?.[0] ? (
          <img src={product.images[0]} alt={product.name} className="w-full h-full object-cover rounded-2xl" />
        ) : (
          <Smartphone size={80} className="text-white/70" strokeWidth={1} />
        )}
      </div>
      <div>
        <div className="flex items-center gap-1 mb-2">
          <Star size={14} className="fill-yellow-400 text-yellow-400" />
          <span className="text-sm font-mono text-white/60">{Number(product.rating).toFixed(1)} ({product.numReviews} reviews)</span>
        </div>
        <h1 className="font-display font-bold text-3xl mb-2">{product.name}</h1>
        <p className="text-mint font-mono text-sm mb-4">{product.spec}</p>
        <p className="text-white/70 mb-6">{product.description}</p>
        <div className="font-mono text-2xl font-semibold mb-6">₹{product.price.toFixed(2)}</div>
        <div className="flex items-center gap-4 mb-6">
          <div className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-full px-4 py-2">
            <button onClick={() => setQty(Math.max(1, qty - 1))}><Minus size={14} /></button>
            <span className="w-6 text-center font-mono">{qty}</span>
            <button onClick={() => setQty(qty + 1)}><Plus size={14} /></button>
          </div>
          <button
            onClick={() => addToCart(product, qty)}
            className="flex-1 bg-accent hover:bg-orange-500 text-black font-semibold rounded-full py-3 text-sm transition"
          >
            Add to cart
          </button>
        </div>
        <div className="text-xs text-white/40 font-mono">{product.stock} in stock · Brand: {product.brand}</div>
      </div>
    </div>
  );
}
